var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFailds = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7970_11941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 0.839844C3.15005 0.839844 0.839844 3.15005 0.839844 5.99984C0.839844 8.84963 3.15005 11.1598 5.99984 11.1598C8.84963 11.1598 11.1598 8.84963 11.1598 5.99984C11.1598 3.15005 8.84963 0.839844 5.99984 0.839844ZM1.55984 5.99984C1.55984 3.5477 3.5477 1.55984 5.99984 1.55984C7.09641 1.55984 8.10012 1.95736 8.87475 2.61616C8.87155 2.61913 8.8684 2.62218 8.86529 2.62529L2.6253 8.86517C2.62217 8.8683 2.61911 8.87148 2.61611 8.87469C1.95735 8.10008 1.55984 7.09638 1.55984 5.99984ZM3.12488 9.38348C3.89952 10.0423 4.90325 10.4398 5.99984 10.4398C8.45199 10.4398 10.4398 8.45199 10.4398 5.99984C10.4398 4.90328 10.0423 3.89957 9.38353 3.12494C9.38055 3.12814 9.37751 3.13129 9.3744 3.13441L3.13441 9.37429C3.13128 9.37743 3.1281 9.38049 3.12488 9.38348Z",
    fill: "#D3170B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7970_11941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFailds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Failds.7879dd9e.svg";
export { ForwardRef as ReactComponent };